import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Wrapper } from "~/components/Wrapper/Wrapper"

import { QuoteWrapper } from "./components/QuoteWrapper/QuoteWrapper"
import styles from "./index.module.css"

export const SocialInvestment: React.FC = () => {
  const { t } = useTranslation()
  const { social } = useApiContext("/sustainable/page")
  const { fact } = social

  return (
    <Wrapper className={styles.Wrapper}>
      <div className="container grid grid--col-12">
        <div className={styles.Content}>
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={t("sustainable-development.SocialInvestment.Title")} />
          </Heading>

          <div className={styles.Description}>
            <p
              dangerouslySetInnerHTML={{
                __html: fact.description,
              }}
            />

            <div className={styles.FootNote} dangerouslySetInnerHTML={{ __html: fact.number }} />
          </div>
        </div>

        <div className={styles.Quote}>{/* <QuoteWrapper /> */}</div>
      </div>
    </Wrapper>
  )
}
